<template>
    <div class="article-data-container">
        <!-- 页面标题 -->
        <header class="page-header">
            <h1 class="page-title">面试面经</h1>
            <p class="page-subtitle">精选前端面试经验与技巧分享</p>
        </header>

        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-box">
                <i class="bi bi-search"></i>
                <input v-model="searchKeyword" type="text" placeholder="搜索面经标题或内容..." class="search-input" />
            </div>
        </div>

        <!-- 加载状态 -->
        <div v-if="loading" class="loading-state">
            <i class="bi bi-arrow-clockwise loading-icon"></i>
            <p>加载中...</p>
        </div>

        <!-- 面经列表 -->
        <!-- 这里的细节就是 计算属性filteredArticles中 双向绑定的searchKeyword为空时 会返回所有文章  当searchKeyword有值时 会根据searchKeyword进行过滤 然后返回过滤后的文章列表 然后进行重新渲染 这样就简单的完成了搜索匹配功能-->
        <div v-if="filteredArticles.length > 0" class="article-list">
            <!-- 使用ArticleInfo组件展示每个面经 -->
            <ArticleInfo v-for="article in filteredArticles" :key="article.id" :article="article"
                @article-click="handleArticleClick" />

            <!-- 加载更多按钮 -->
            <button v-if="hasMore" @click="loadMore" class="load-more-btn" :disabled="loadingMore">
                {{ loadingMore ? '加载中...' : '加载更多' }}
            </button>
        </div>

        <!-- 空状态 -->
        <div v-else class="empty-state">
            <i class="bi bi-journal-text fs-1 text-muted"></i>
            <h3>暂无面经数据</h3>
            <p>试试搜索其他关键词</p>
        </div>
    </div>
</template>

<script>
import ArticleInfo from '@/components/ArticleInfo.vue'

export default {
    name: 'ArticleData',
    components: {
        ArticleInfo
    },
    data() {
        return {
            // 面经数据列表
            articles: [
                {
                    id: 1,
                    title: '前端面试常问问题汇总2024版',
                    summary: '包含HTML5、CSS3、JavaScript ES6+、Vue3、React等现代前端技术栈的面试高频问题，附详细答案解析...',
                    views: 1234,
                    likes: 89,
                    comments: 45,
                    publishTime: '2024-01-15T10:30:00',
                    tags: ['前端', '面试', 'JavaScript']
                },
                {
                    id: 2,
                    title: 'Vue3 面试题深度解析',
                    summary: 'Vue3 新特性、Composition API、响应式原理、性能优化等核心面试题详解，包含实际项目经验分享...',
                    views: 856,
                    likes: 67,
                    comments: 23,
                    publishTime: '2024-01-14T15:20:00',
                    tags: ['Vue3', '面试', '前端框架']
                },
                {
                    id: 3,
                    title: 'React Hooks 最佳实践与面试要点',
                    summary: '深入讲解useState、useEffect、useContext、useReducer等常用Hooks的使用场景、注意事项及面试常见陷阱...',
                    views: 742,
                    likes: 54,
                    comments: 31,
                    publishTime: '2024-01-13T09:15:00',
                    tags: ['React', 'Hooks', '面试']
                },
                {
                    id: 4,
                    title: 'HTML5+CSS3 现代布局技巧完全指南',
                    summary: '深入解析Flexbox、Grid布局系统，响应式设计最佳实践，移动端适配方案，以及CSS动画与过渡的高级技巧...',
                    author: '前端架构师',
                    views: 2341,
                    likes: 156,
                    comments: 78,
                    publishTime: '2024-01-20T09:30:00',
                    tags: ['HTML5', 'CSS3', '布局', '响应式'],
                    content: '完整的HTML5+CSS3布局教程...',
                    questions: [
                        {
                            question: 'Flexbox和Grid布局如何选择？',
                            answer: 'Flexbox适合一维布局（行或列），Grid适合二维布局（行列同时控制）。简单线性布局用Flexbox，复杂网格用Grid。'
                        }
                    ]
                },
                {
                    id: 5,
                    title: 'Axios 从入门到精通的完整教程',
                    summary: '全面讲解Axios的配置、拦截器、错误处理、并发请求、取消请求等高级功能，以及在实际项目中的最佳实践...',
                    author: 'API大师',
                    views: 1892,
                    likes: 143,
                    comments: 65,
                    publishTime: '2024-01-19T14:20:00',
                    tags: ['Axios', 'HTTP', 'JavaScript', '网络请求'],
                    content: 'Axios完整使用指南...',
                    questions: [
                        {
                            question: '如何处理Axios的全局错误？',
                            answer: '使用拦截器统一处理：request拦截器添加token，response拦截器统一处理错误码。'
                        }
                    ]
                },
                {
                    id: 6,
                    title: 'Vue3 组合式API深度解析与实战',
                    summary: '详细讲解Composition API的核心概念、响应式原理、自定义Hook开发，以及从Options API迁移的最佳实践...',
                    author: 'Vue核心贡献者',
                    views: 3215,
                    likes: 267,
                    comments: 134,
                    publishTime: '2024-01-18T11:15:00',
                    tags: ['Vue3', 'Composition API', '前端框架', '实战'],
                    content: 'Vue3组合式API全方位教程...',
                    questions: [
                        {
                            question: 'Composition API相比Options API的优势？',
                            answer: '更好的逻辑复用、更灵活的代码组织、更好的TypeScript支持、更小的打包体积。'
                        }
                    ]
                },
                {
                    id: 7,
                    title: 'JavaScript 异步编程从回调到Async/Await',
                    summary: '系统梳理JS异步编程的演进历程：回调函数、Promise、Generator、Async/Await，以及错误处理策略...',
                    author: 'JS专家',
                    views: 1654,
                    likes: 198,
                    comments: 89,
                    publishTime: '2024-01-17T16:45:00',
                    tags: ['JavaScript', '异步编程', 'Promise', 'Async/Await'],
                    content: 'JavaScript异步编程全解析...',
                    questions: [
                        {
                            question: 'Promise和Async/Await的区别？',
                            answer: 'Async/Await是基于Promise的语法糖，更简洁的异步代码写法，避免了回调地狱。'
                        }
                    ]
                },
                {
                    id: 8,
                    title: 'TypeScript 在Vue3项目中的最佳实践',
                    summary: 'TypeScript与Vue3完美结合：类型定义、组件props类型、事件类型、Composition API类型推断等高级用法...',
                    author: '类型体操大师',
                    views: 1423,
                    likes: 176,
                    comments: 71,
                    publishTime: '2024-01-16T13:30:00',
                    tags: ['TypeScript', 'Vue3', '类型系统', '最佳实践'],
                    content: 'Vue3+TypeScript最佳实践...',
                    questions: [
                        {
                            question: 'Vue3中如何定义组件的props类型？',
                            answer: '使用defineProps宏函数，支持运行时和类型级别的双重验证。'
                        }
                    ]
                }
            ],
            searchKeyword: '',
            loading: false,
            hasMore: true,
            loadingMore: false
        }
    },
    computed: {
        /**
         * 根据搜索关键词过滤面经
         * 支持标题和摘要的模糊搜索
         */
        filteredArticles() {
            // 如果没有搜索关键词，继续返回所有文章

            if (!this.searchKeyword.trim()) {
                return this.articles
            }
            const keyword = this.searchKeyword.toLowerCase()
            return this.articles.filter(article =>
                article.title.toLowerCase().includes(keyword) ||
                article.summary.toLowerCase().includes(keyword) ||
                article.tags.some(tag => tag.toLowerCase().includes(keyword))
            )
        }
    },
    methods: {
        /**
         * 处理面经点击事件
         * 跳转到详情页，携带文章ID
         * @param {number} articleId - 被点击的文章ID
         */
        handleArticleClick(articleId) {
            // 使用编程式导航跳转到详情页
            this.$router.push({
                name: 'articleDetail',
                params: { id: articleId }
            })
        },
        /**
         * 加载更多面经数据
         * 模拟分页加载效果
         */
        loadMore() {
            this.loadingMore = true
            // 模拟API调用延迟
            setTimeout(() => {
                // 这里可以添加实际的数据加载逻辑
                this.hasMore = false
                this.loadingMore = false
            }, 1000)
        },

        /**
         * 搜索功能实现
         * 防抖处理，避免频繁搜索
         */
        handleSearch: debounce(function () {
            // 搜索逻辑已在前面的filteredArticles中实现
        }, 300)
    },
    created() {
        // 组件创建时初始化数据
        this.loading = true
        setTimeout(() => {
            this.loading = false
        }, 500)

    },
}

/**
 * 防抖函数工具
 * @param {Function} func - 需要防抖的函数
 * @param {number} delay - 延迟时间（毫秒）
 * @returns {Function} 防抖后的函数
 */
function debounce(func, delay) {
    let timeoutId
    return function (...args) {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
            func.apply(this, args)
        }, delay)
    }
}
</script>

<style scoped>
.article-data-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}

.page-header {
    text-align: center;
    margin-bottom: 30px;
}

.page-title {
    color: #1a1a1a;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 8px;
}

.page-subtitle {
    color: #666;
    font-size: 16px;
}

.search-section {
    margin-bottom: 30px;
}

.search-box {
    position: relative;
    max-width: 500px;
    margin: 0 auto;
}

.search-box i {
    position: absolute;
    left: 15px;
    top: 50%;
    /* 居中对齐 */
    transform: translateY(-50%);
    color: #999;
}

.search-input {
    width: 100%;
    padding: 12px 45px;
    border: 1px solid #e0e0e0;
    border-radius: 25px;
    font-size: 16px;
    outline: none;
    transition: all 0.3s ease;
}

.search-input:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.loading-state {
    text-align: center;
    padding: 60px 20px;
    color: #999;
}

.loading-icon {
    animation: spin 1s linear infinite;
    margin-bottom: 15px;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.load-more-btn {
    display: block;
    margin: 30px auto;
    padding: 12px 40px;
    background: #1890ff;
    color: white;
    border: none;
    border-radius: 25px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.load-more-btn:hover:not(:disabled) {
    background: #40a9ff;
    transform: translateY(-1px);
}

.load-more-btn:disabled {
    background: #d9d9d9;
    cursor: not-allowed;
}

.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #999;
}

.empty-state h3 {
    margin: 15px 0 10px;
    color: #666;
}
</style>
